var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-switcher"},[_c('icon-button',{attrs:{"icon":_vm.currentTheme === 'dark' ? 'moon' : 'sun'},on:{"click":_vm.toggleTheme}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }